module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_redefine.js
// module id = 54
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/modules/_redefine.js